import { AppThunk } from '@store/index';
import { sliceActions } from '@store/user/user.slice';
import { userApi } from 'src/apis/index';
import cookies from 'react-cookies';
import Router from 'next/router';

export const getUserInfo = (): AppThunk => async (dispatch) => {
  try {
    dispatch(sliceActions.getUserInfoInitiate());
    const { data } = await userApi.getUserInfo();
    dispatch(sliceActions.getUserInfoSuccess(data));
  } catch (error) {
    dispatch(sliceActions.getUserInfoFaild());
  }
};

export const logout = (): AppThunk => (dispatch) => {
  Router.replace('/');
  cookies.remove('access_token', { path: '/' });
  cookies.remove('refresh_token', { path: '/' });
  dispatch(sliceActions.getUserInfoInitiate());
};

export const self = sliceActions;
